import React, {useEffect, useReducer, useState} from "react";
import ExploreCard from "./components/ExploreCard";
import { useSelector} from "react-redux";
import { map_coins, map_coin_to_name, map_untradable_kraken_assets} from 'store/constant';
import FavoritesCard from '../Favorites/components/FavoritesCard';
import { Grid, Box, Typography, Tab, Tabs, Chip, Badge } from "@material-ui/core";
import SubCard from "ui-component/cards/SubCard";
import DeleteIcon from '@material-ui/icons/Delete';
import CancelIcon from '@material-ui/icons/Cancel';
import { useDispatch } from "react-redux";
import MultiChart from "../MultiChart";
import SecondChart from "../SecondChart";
import {
  TAB_DEL_PINNED_COIN, 
} from "store/actions";
import colors from 'assets/scss/_themes-vars.module.scss';
// material-ui
import { makeStyles, useTheme } from "@material-ui/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@material-ui/core";


const CoinDetails = ({coin,onDelete}) => {
  const key_style = map_coins.get(coin);

  const ltp  = useSelector((state) => {
    return state.coins.kraken_asset_pairs.get(coin) || {ltp: 0.00};
    });

    // console.log(ltp);

    // const move = item.move === "↓↓↓" ? "down" : "up";
    // const rung = item.move === "↓↓↓" ? "#FAA" : "rgb(132, 237, 102)";

    return (
    <div style={{position:'relative'}}>

      <div style={{position:'absolute', top:'-12px', right: '-12px'}} onClick={() => onDelete(coin)}>
        <CancelIcon  />
      </div>
      <div
      style={{
        height: '35px',
        width: '90px',
        boxAlign: 'center',
        alignItems: 'center',
        padding: '0px',
        backgroundColor: '#000',
        borderRadius: '0px',
        border: '0px solid rgb(68 68 68)',
        whiteSpace: 'nowrap',
      }}
      >
        <div>
        <font sx={{ "font-size": "0.8rem" }} class={key_style} >{coin}</font>

        </div>
        <div>
        <font sx={{ 'color': 'white', "font-size": "0.8rem" }} >{ltp.ltp}</font>
        </div>
      </div>
      {/* </Badge> */}

    </div>)
}
 

const Explore = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const background = (theme.palette.mode === 'dark') ? '#00070f' : '#fff';
  const [, forceUpdate] = useReducer(x => x + 1, 0);

  const whiteTakyon = theme.palette.mode === "dark" ? colors.whiteLightTakyon : colors.whiteDarkTakyon;
  const cornsilk = theme.palette.mode === "dark" ? colors.cornsilkLightTakyon : colors.cornsilkDarkTakyon;

  const explore_list = useSelector((state) => {
    return state.coins.kraken_asset_pairs;
  });
  // TMD console.log( '----------- EXPLORE LIST --------------- ');
  // TMD console.log(explore_list);
  
 const tabbed =  useSelector((state) => {

  return   state.coins.explore_tabs.map(tab => ({
    coin:tab,
    ltp: state.coins.kraken_asset_pairs.get(tab) || 0.000
  })) 
  });

  // console.log(map_tabbed_coins);


  // const [mapTabbedCoins, setMapTabbedCoins] = useState([]);

  const explore_tabs = useSelector((state) => {
    return state.coins.explore_tabs;
  });



  // useEffect(()=>{
  //   setMapTabbedCoins(explore_tabs)
  //   setTimeout(()=>{
  //     setMapTabbedCoins(explore_tabs.map((tab)=>tab))
  //   },3000)

  //   return 
  // },[]);

  
// setTimeout(()=>{setCoins([])},2000)

  //instead of realtime price changes  -  make  price updating every 3-5 sec 

  // useEffect(()=>{

  //   useSelector((state) => {
  //     state.coins.explore_tabs.forEach((key, index) => {
  //         if ( state.coins.kraken_asset_pairs.get(key))
  //         {
  //             map_tabbed_coins.push(state.coins.kraken_asset_pairs.get(key));
  //         }
  //     });
  //   });


  // },[map_tabbed_coins])

  const [tabsValue, setTabsValue] = React.useState(0);
  const handleChangeTab = (event, newValue) => {
    setTabsValue(newValue);
  };

  let favcoins = useSelector((state) => state.favorites.favorites);
  // TMD console.log(favcoins);
  const flen = favcoins.length;

  const mc = Array.from({length: 12}, () => flen);
  for( let i = 1; i <= 12; ++i)
  {
        if ( i <= mc[i-1])
        {
            mc[i-1] -= i;
        } else {
            mc[i-1] = (mc[i-1] - i + 12)%flen;
        }
        // console.log(mc[i-1]);
        // console.log(favcoins[mc[i-1]]);
  }
  

  const handleDeleteTab  = (coin) => {
    if(explore_tabs.length < 2) {
      setTabsValue(0);
    }
    dispatch({type: TAB_DEL_PINNED_COIN, payload: {coin}});
    forceUpdate();
  }

  return (
    <>
        <Tabs
            value = {tabsValue}
            onChange={handleChangeTab}
            aria-label="ant example"
          >
            {/*
            <Tab
                    label={
                        <Chip
                            variant="outlined" 
                            sx={{color: 'black', bgcolor:'lightgreen'}}
                            label={<font style={{ "font-size": "0.8rem" }} >Charts</font> }
                        />
                     } 
            />
            */}
            <Tab
                    label={
                        <Chip
                            variant="outlined" 
                            sx={{color: 'white', bgcolor:'lightred'}}
                            label={<font style={{ "font-size": "0.8rem" }} >Explore</font> }
                        />
                     } 
            />
                    
                 { 
                 explore_tabs.map((tab) =>(
                  <Tab key={tab.toString()} label={<CoinDetails coin={tab}
                  onDelete={handleDeleteTab}
                  />}  />
                 ))
                 }
          </Tabs>

            <Grid container spacing={0.0} padding={0.0} />
              {tabsValue === 0 && <ExploreCard title="ExploreCard" rows={explore_list} />}
              {/***tabsValue === 0 && 
                <TableContainer padding={0} spacing={0}>
                    <TableBody padding={0} spacing={0}>
                        <Grid items xs={12}>
                        <TableRow key={0} padding={0} spacing={0}>
                            <TableCell key={0} padding={0} spacing={0}>
                                <SecondChart index={0} coin={favcoins[mc[0]].label} />
                            </TableCell>
                            <TableCell key={11} padding={0} spacing={0}>
                                <SecondChart index={11} coin={favcoins[mc[11]].label} />
                            </TableCell>
                            <TableCell key={10} padding={0} spacing={0}>
                                <SecondChart index={10} coin={favcoins[mc[10]].label} />
                            </TableCell>
                            <TableCell key={9} padding={0} spacing={0}>
                                <SecondChart index={9} coin={favcoins[mc[9]].label} />
                            </TableCell>
                        </TableRow>
                        </Grid>
                        <Grid items xs={12}>
                        <TableRow key={1} padding={0} spacing={0}>
                            <TableCell key={8} padding={0} spacing={0}>
                                <SecondChart index={8} coin={favcoins[mc[8]].label} />
                            </TableCell>
                            <TableCell key={7} padding={0} spacing={0}>
                                <SecondChart index={7} coin={favcoins[mc[7]].label} />
                            </TableCell>
                            <TableCell key={6} padding={0} spacing={0}>
                                <SecondChart index={6} coin={favcoins[mc[6]].label} />
                            </TableCell>
                            <TableCell key={5} padding={0} spacing={0}>
                                <SecondChart index={5} coin={favcoins[mc[5]].label} />
                            </TableCell>
                        </TableRow>
                        </Grid>
                        <Grid items xs={12}>
                        <TableRow key={2} padding={0} spacing={0}>
                            <TableCell key={4} padding={0} spacing={0}>
                                <SecondChart index={4} coin={favcoins[mc[4]].label} />
                            </TableCell>
                            <TableCell key={3} padding={0} spacing={0}>
                                <SecondChart index={3} coin={favcoins[mc[3]].label} />
                            </TableCell>
                            <TableCell key={2} padding={0} spacing={0}>
                                <SecondChart index={2} coin={favcoins[mc[2]].label} />
                            </TableCell>
                            <TableCell key={1} padding={0} spacing={0}>
                                <SecondChart index={1} coin={favcoins[mc[1]].label} />
                            </TableCell>
                        </TableRow>
                        </Grid>
                    </TableBody>
                </TableContainer>
              ***/}
              {tabsValue > 0 && <FavoritesCard coin={explore_tabs[tabsValue - 1]} />}
    </>
  );
};

export default (Explore);
